import React from 'react';
import styled from 'styled-components';

import { P } from '../../styles/typography';
import Grid, { GridRow } from '../../styles/grid';
import { mediaMax } from '@styles/sizes';

import Layout from '../../components/layout';
import SEO from '../../components/seo';
import Container from '../../components/Container/Container';
import { Wrapper } from '../../components/Container/Wrapper';
import Image from '../../components/Image/Image';
import Panel, {
  PanelRow,
  PanelTitle,
  PanelDescription,
  PanelReadMore,
} from '../../components/Panel/Panel';
import Title from '../../components/Template/Title';
import PageTransition from '../../components/pageTransition';
import { graphql, StaticQuery } from 'gatsby';

const StyledGridRow = styled(GridRow)`
  margin-bottom: 64px;
  ${mediaMax.tablet`
    display: block;
  `}
`;

const StyledPanel = styled(Panel)`
  background: #f1f5f2;
  height: 340px;
  flex-grow: 1;
  flex-basis: 0;
  ${mediaMax.tablet`
    height: auto;
    margin-bottom: 16px;
    flex-basis: auto;
  `}
`;

const StyledAboutContent = styled.div`
  max-width: 700px;
`;

const StyledContainer = styled(Container)`
  margin-bottom: 64px;
`;

const AboutPage = () => (
  <StaticQuery
    query={graphql`
      query Aboutpage {
        site {
          siteMetadata {
            blocks {
              wild
              life
              film
            }
          }
        }
      }
    `}
    render={data => (
      <Layout>
        <SEO title="About" />
        <PageTransition>
          <Wrapper>
            <Title>About Reel Nature</Title>
            <StyledContainer>
              <StyledGridRow>
                <Grid md={5}>
                  <P strong>
                    Reel Nature is a Zambian Registered Company, providing film
                    crew support services, fixing and ultimately remote location
                    support, kit and equipment; a one-stop-shop with no need for
                    middlemen!
                  </P>
                  <P>
                    Reel Nature is an offshoot of Jeffery & McKeith Safaris, who
                    have worked with wildlife and documentary film crews since
                    2012 and offer a highly professional and efficient service
                    from the first researchers email to the final day departure
                    of the film crew.
                  </P>
                </Grid>
                <Grid pushMd={1} md={6}>
                  <Image src={'about.jpg'} caption={'The Reel Nature Team'} />
                </Grid>
              </StyledGridRow>
              <PanelRow>
                <StyledPanel>
                  <PanelTitle>Wild.</PanelTitle>
                  <PanelDescription>
                    {data.site.siteMetadata.blocks.wild}
                  </PanelDescription>
                  <PanelReadMore url={'/about/wild'} />
                </StyledPanel>
                <StyledPanel>
                  <PanelTitle>Life.</PanelTitle>
                  <PanelDescription>
                    {data.site.siteMetadata.blocks.life}
                  </PanelDescription>
                  <PanelReadMore url={'/about/life'} />
                </StyledPanel>
                <StyledPanel>
                  <PanelTitle>Film.</PanelTitle>
                  <PanelDescription>
                    {data.site.siteMetadata.blocks.film}
                  </PanelDescription>
                  <PanelReadMore url={'/about/film'} />
                </StyledPanel>
              </PanelRow>
            </StyledContainer>
            <Container>
              <StyledAboutContent>
                <h3>Full of Experience</h3>
                <P>
                  With over 20 years combined experience in the wildlife and
                  tourism sector there are very few areas that the crew do not
                  know intimately and remote location operations is something
                  they are well known for (they won the prestigious ‘Safari
                  Awards’ in 2016 for ‘Best Mobile Safari Operator’). This is
                  ultimately what gave the team their first filmmaking support
                  opportunity in 2012 with BBC EARTH for ‘Enchanted Kingdom -
                  3D’. On top of all of this the crew are all very keen
                  photographers and amateur videographers, with a plethora of
                  experience with a whole host of equipment and scenarios.
                </P>
                <P>
                  Reel Nature is based in Lusaka, offering not only a wealth of
                  knowledge and expertise but also owning and running their own
                  fleet of film making vehicles and support equipment (see
                  here), setting them apart from other fixers and logistical
                  support companies in the region. Flexibility being the key to
                  each and every shoot, we have had crews from the US and the
                  UK, some requiring simple guiding/vehicle support and others a
                  full ‘fixed’ shoot, from press accreditation and importation
                  services to making sure our dedicated remote location chef
                  caters for all sorts of dietary needs.
                </P>
              </StyledAboutContent>
            </Container>
          </Wrapper>
        </PageTransition>
      </Layout>
    )}
  />
);

export default AboutPage;
